<template>
  <div class="w-banner" :style="{backgroundImage:`url(${bgsrc})`}">
    <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
      <slot></slot>
    </Animation>
  </div>
</template>

<script>
import Animation from '@/components/Animation.vue'

export default {
  props: {
    bgsrc: {
      type: String
    }
  },
  components: {
    Animation
  },
};
</script>

<style scoped lang="scss">
</style>
